<template>
    <div v-if="scope.row[config.prop]">
        <div>
            <i class="time-flag-start">起</i
            >{{ scope.row[config.prop].begin_date }}
        </div>
        <div>
            <i class="time-flag-end">止</i>{{ scope.row[config.prop].end_date }}
        </div>
    </div>
    <div v-else>
      无对应字段~
    </div>
</template>

<script>

export default {
    name: "TBeTime",
    cName:'起止时间',
    defaultProp:'be_time',
    // functional: true,
    // Props 是可选的
    props: ["scope", "config"],
    data() {
        return {
        };
    }
};
</script>
